import { fetchJSON } from '@catalogo/core-http';
import { stringify } from 'query-string';
import { getIn } from 'seamless-immutable';
import { readCookies } from '@catalogo/core-connect/cookies';

export default (config, cache) => async (_, args) => {
  if (!args.cep || args.cep.length < 8) {
    return null;
  }

  const products = args.products.map(product =>
    JSON.stringify({
      sku: product.sku,
      promotionedPrice: product.price,
      condition: product.condition || 'NEW',
      quantity: product.quantity || 1,
      storeId: product.storeId,
      sellerStoreId: product.sellerStoreId,
    })
  );

  const { cookies } = readCookies(cache);
  const customerId = cookies?.['customer.id'] || '';
  const params = stringify({
    cep: args.cep,
    customerId,
    product: products,
  });
  try {
    return await fetchJSON(`https://freight-v3-americanas.b2w.io/freight?${params}`).then(data => {
      delete data.id;
      return {
        __typename: 'Freight',
        error: null,
        ...data,
        options: getIn(data, ['options'], []).map(option => ({
          __typename: 'FreightOption',
          ...option,
          products: option.products.map(product => ({
            ...product,
            __typename: 'FreightProductDetails',
            details: {
              shipstoreSalesClosingTime: null,
              ...product.details,
            },
            discount: {
              total: 0,
              ...product.discount,
            },
          })),
          eta: {
            businessDays: null,
            ...option.eta,
          },
        })),
      };
    });
  } catch (e) {
    return { __typename: 'Freight', error: e.body };
  }
};
